import Velocity from 'velocity-animate';

export default function initAnkers () {
	const ankers = document.querySelectorAll('.js-anker');

	if (!ankers.length) return;

	[...ankers].map(a => {
		a.addEventListener('click', function (e) {
			e.preventDefault();

			const target = document.querySelector(this.hash);

			Velocity(
				target,
				'scroll',
				{
					duration: 700,
					offset: 0,
				}
			);
		})
	});
}
